import { render, staticRenderFns } from "./BulkContractServiceEditor.yaml?vue&type=template&id=29c61da3&component"
import script from "./BulkContractServiceEditor.yaml?vue&type=script&lang=ts&component"
export * from "./BulkContractServiceEditor.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports